// Module
var code = `<div class="page-content plans">

    <section class="plans">

        <p class="plans__eyebrow">
            Plans · Open source today, paid tiers when they're ready
        </p>

        <h1 class="plans__headline">
            SpyneJS is free.
        </h1>

        <p class="plans__subhead">
            The framework, the <b>Application Builder</b>, the <b>CMS</b>, <b>Agent Skills</b>, the <b>Workbench preview</b> &mdash; every part of SpyneJS that ships today is open source or free to use. There is no paid tier to evaluate against and nothing held back behind one.
        </p>

        <p class="plans__body">
            Pricing arrives when the Workbench moves to general availability and we begin routing AI compute on your behalf. Until then, everything you can build with SpyneJS today, you can build for free.
        </p>

        <div class="plans__primary-cta-row">
            <a  data-channel="ROUTE" data-page-id="configure" data-end-route="true" data-event-prevent-default="true" href="/configure" class="plans__primary-cta build-link">
                Build a SpyneJS application <span class="plans__primary-cta-arrow">&rarr;</span>
            </a>
        </div>

        <div class="plans__future">

            <h2 class="plans__future-heading">What’s Next</h2>

            <p class="plans__future-intro">
                Two paid offerings will follow the public release. We're sharing the shape of each now so teams can plan, but neither is available to purchase today.
            </p>

            <div class="plans__future-grid">

                <div class="plans__tier">
                    <h3 class="plans__tier-name">Pro</h3>
                    <p class="plans__tier-body">
                        When the Workbench reaches general availability, Pro will cover production AI generation through the platform, billed against actual usage. It's the plan for teams who want SpyneJS to host the AI generation surfaces their applications run through.
                    </p>
                    <p class="plans__tier-body">
                        Pricing is being finalized now. Early access members will get at least 60 days notice before any plan begins charging.
                    </p>
                    <a  data-event-prevent-default="true" data-end-route="true" data-channel="ROUTE" data-page-id="early-access" href="/early-access" class="plans__tier-cta plans__early-access">
                        Join early access <span class="plans__tier-cta-arrow">&rarr;</span>
                    </a>
                </div>

                <div class="plans__tier">
                    <h3 class="plans__tier-name">Enterprise</h3>
                    <p class="plans__tier-body">
                        For organizations integrating SpyneJS into proprietary AI infrastructure, migrating away from legacy frontend stacks, or building SpyneJS into existing identity, content, or deployment systems. The SpyneJS team partners directly on architecture, integration, and rollout.
                    </p>
                    <p class="plans__tier-body">
                        This is a partnership engagement, not a license tier &mdash; every Enterprise relationship starts with a conversation about what you're building and where SpyneJS fits.
                    </p>
                    <a target="_blank" href="mailto:frank@spynejs.com" class="plans__tier-cta">
                        Contact the team <span class="plans__tier-cta-arrow">&rarr;</span>
                    </a>
                </div>

            </div>

        </div>

    </section>

</div>


<!--
<div class="page-content pricing">
    <div class="pricing-header">
        <h3>{{block.0.head}}</h3>
        <h4>{{block.0.subhead}}</h4>
        <p>{{block.0.body}}</p>

    </div>


    <div class="pricing-container">


    </div>

</div>
-->
`;
// Exports
module.exports = code;